import { Catalog } from 'react-planner';
import * as Items from './items/index';
import * as Areas from './areas/index';
import * as Lines from './lines/index';
import * as Holes from './holes/index';
import * as Annotations from './annotations/index';
import * as Pipes from './pipes/index';
import * as Fittings from './fittings/index';
import Translate from "../common/functions/translate";
//import LocalProductsService from '../services/localDataServices/localProductsService';

//export default catalog;

export function GetCatalog() {
    let catalog = new Catalog();
    //let localProductsService = new LocalProductsService();
    let others = [];

    for (let x in Lines) {
        catalog.registerElement(Lines[x]);
        others.push(Lines[x])
    }

    for (let x in Areas) {
        catalog.registerElement(Areas[x]);
        others.push(Areas[x])
    }

    for (let x in Pipes) {
        Pipes[x].info.title = Translate(Pipes[x].info.title);
        Pipes[x].info.description = Translate(Pipes[x].info.description);
        catalog.registerElement(Pipes[x]);

        others.push(Pipes[x])
    }

    for (let x in Holes) {
        catalog.registerElement(Holes[x]);
    }

    for (let x in Annotations) {
        Annotations[x].info.title = Translate(Annotations[x].info.title);
        Annotations[x].info.description = Translate(Annotations[x].info.description);
        catalog.registerElement(Annotations[x]);
    }

    for (let x in Items) {
        Items[x].info.title = Translate(Items[x].info.title);
        Items[x].info.description = Translate(Items[x].info.description);
        catalog.registerElement(Items[x]);
        if (Items[x].name !== 'gas-board' && Items[x].name !== 'gas-measuring-board' && Items[x].name !== '[pipe]vertical-gas-pipe')
            others.push(Items[x]);
    }

    for (let x in Fittings) {
        Fittings[x].info.title = Translate(Fittings[x].info.title);
        Fittings[x].info.description = Translate(Fittings[x].info.description);
        catalog.registerElement(Fittings[x]);
    }

    catalog.registerCategory('windows', Translate('Windows'), [Holes.Window, Holes.SashWindow, Holes.VenetianBlindWindow, Holes.WindowCurtain], true);
    catalog.registerCategory('doors', Translate('Doors'), [Holes.Door, Holes.DoorDouble, Holes.Gate, Holes.PanicDoor, Holes.PanicDoorDouble, Holes.SlidingDoor], true);
    catalog.registerCategory('annotations', Translate('Annotations'), [Annotations.Text, Annotations.Label, Annotations.NorthSign, Annotations.ElevationSign,
    Annotations.CirclePointer, Annotations.ChimneySign], false);
    catalog.registerCategory('hidden', 'Hidden', others, true);
    catalog.registerCategory('fittings', Translate('Fittings'), [Fittings.MagnetVentil, Fittings.TransitionalHolender, Fittings.Coupling, Fittings.Nipel,
    Fittings.Triple, Fittings.Ventil, Fittings.Elbow], false);
    return catalog;
}
